import mutations from './mutations';
import actions from './actions';
import state from './state';

const userGroups = {
  namespaced: true,
  actions,
  state,
  mutations,  
};

export default userGroups;
